/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Wizard_OpenInputs */

const cs_portals_wizard_open = /** @type {(inputs: Portals_Wizard_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Průvodce připojením`)
};

const en_portals_wizard_open = /** @type {(inputs: Portals_Wizard_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection wizard`)
};

/**
* | output |
* | --- |
* | "Connection wizard" |
*
* @param {Portals_Wizard_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_wizard_open = /** @type {((inputs?: Portals_Wizard_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Wizard_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_wizard_open(inputs)
	return cs_portals_wizard_open(inputs)
});